import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { selectorIsReviewStrategyApproval } from "./selectorIsReviewStrategyApproval";

/**
 * Whether this requirement runs an approval flow — the payer reviews what the
 * contractor submits, rather than the requirement completing on its own.
 *
 * Read straight off the instance's `reviewPolicy` (`AlwaysRequired` and `OnFail`
 * both mean an approval flow, `NeverRequired` does not). This replaces a proxy
 * off the instance's own review signals — status, payer override, approved and
 * rejected events — which could only recognize a requirement that had already
 * been reviewed, and so under-detected one still awaiting its first review.
 */
export const selectorIsRequirementWithApprovalFlow = (
  requirement: PayeeRequirement
) => selectorIsReviewStrategyApproval(requirement.reviewPolicy);
